module.exports = __webpack_public_path__ + "img/bab.0b546225.svg";